import { PureComponent } from 'react';

class Boolean extends PureComponent {
    render() {
        const { id, className, value, trueValue = 'Yes', falseValue = 'No', emptyText = '--' } = this.props;
        const attrs = { id, className };
        let displayValue = null;

        if (value === 1 || value === '1' || value === true || value === 'true') {
            displayValue = trueValue;
        } else if (value === 0 || value === '0' || value === false || value === 'false') {
            displayValue = falseValue;
        } else {
            displayValue = emptyText;
        }

        return <span {...attrs}>{displayValue}</span>;
    }
}

export default Boolean;
